import { CustomEventCommand } from './../../../commands/hub/custom.event.command';
import { Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../common/components';
import {
  AIEventClassificationModalActions,
  AIEventClassificationModalData,
} from './ai.event.classification.modal.provider';
import { HubEvent } from '../../../models/hub/hub.event';
import { CustomizationApiService } from '../../../services/customization.api.service';
import { VisitorApiService } from '../../../services/visitor.api.service';

@Component({
  templateUrl: './ai.event.classification.modal.component.html',
  styleUrls: ['./ai.event.classification.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AIEventClassificationModalComponent extends BaseComponent {
  public hubName: string | undefined;
  public events: { _id: string; name: string; categories?: { _id: string; name: string }[] }[] = [];
  public customCategories: CustomEventCommand[] = [];
  public isClassifying = false;
  public isClassified = false;
  public defaultSuggestedCategories = [
    'Adult Preferred',
    'Cultural',
    'Dining Experiences',
    'Family Friendly',
    'Music & Festivals',
    'Live Performance',
    'Sports Competitions',
  ];

  constructor(
    private dialogRef: MatDialogRef<AIEventClassificationModalComponent>,
    private actions: AIEventClassificationModalActions,
    private hubApiService: HubApiService,
    private visitorApiService: VisitorApiService,
    public imageService: ImageService,
    private formBuilder: FormBuilder,
    private customizationService: CustomizationApiService,
    data: AIEventClassificationModalData
  ) {
    super();

    this.hubName = data.hubName;

    customizationService.getCustomEvent(this.hubName).subscribe((data) => {
      this.customCategories = data.customEvents || [];
      console.log('customCategories', this.customCategories);
    });

    hubApiService
      .getEvents(this.hubName, {
        isApproved: true,
        limit: 9999,
        page: 1,
        projection: 'name startTime endTime eventTimes',
      })
      .subscribe((events: HubEvent[]) => {
        this.events = events.map((x) => {
          return {
            _id: x._id,
            name: x.name,
            categories: [],
          };
        });
      });
  }

  public close(): void {
    // if (this.actions.cancel) {
    //   this.actions.cancel();
    // }

    this.dialogRef.close();
  }

  public async confirm(event: ButtonTriggerEvent) {
    // const categories = this.defaultSuggestedCategories.map((x) => `"${x}"`).join('; ');
    const categories = this.customCategories.map((c) => `"${c.btnText}"`).join('; ');
    this.isClassifying = true;
    this.hubApiService
      .aiAssistant(this.hubName, {
        query: `The events names are: ${this.events
          .map((x) => `"${x.name}"`)
          .join('; ')}. The categories are: ${categories}.`,
        model: 'chatgpt',
        feature: 'classifyEventsToCustomCategories',
      })
      .finally(() => {
        event.complete();
        this.isClassifying = false;
      })
      .subscribe((data) => {
        if (data.success) {
          const json = JSON.parse(data.data);
          console.log(json);

          this.mapEventCategories(json);

          this.isClassified = true;
        } else {
          alert('Error when classifying!');
        }
      });
    // this.actions.confirm(event, {});
    // this.dialogRef.close();
  }

  public save(event: ButtonTriggerEvent) {
    this.hubApiService
      .bulkClassifyEventCategories(this.hubName, this.events)
      .finally(event.complete)
      .subscribe((data) => {});
  }

  public addCategory(event, category: CustomEventCommand) {
    if (this.isClassifying || event.categories.any((x) => x._id === category._id)) return;

    event.categories.push({
      _id: category._id,
      name: category.btnText,
    });
  }

  public aiGenerateCategories(event: ButtonTriggerEvent) {
    this.hubApiService
      .aiAssistant(this.hubName, {
        query: `The events names are: ${this.events.map((x) => `"${x.name}"`).join('; ')}.`,
        model: 'chatgpt',
        feature: 'generationEventCategories',
      })
      .finally(() => {
        event.complete();
        this.isClassifying = false;
      })
      .subscribe((data) => {
        if (data.success) {
          const json = JSON.parse(data.data);
          console.log(json);

          if (!json['extractedCategories']) {
            alert('Something went wrong. Please try again.');
            return;
          }

          this.customCategories = json['extractedCategories'].map((category) => {
            return {
              btnText: category,
            };
          });

          this.mapEventCategories(json);
        }
      });
  }

  public removeCategory(event, category) {
    event.categories = event.categories.filter((x) => x !== category);
  }

  private mapEventCategories(json) {
    for (const e of this.events) {
      try {
        if (json.hasOwnProperty(e.name)) {
          e.categories = json[e.name].map((x) => {
            const custom = this.customCategories.find((y) => y.btnText === x);
            return custom
              ? {
                  _id: custom._id,
                  name: custom.btnText,
                }
              : null;
          });
          e.categories = e.categories ? e.categories.filter((x) => !!x) : [];
        }
      } catch (error) {
        console.log(error);
        console.log(e.name);
        console.log(json[e.name]);
      }
    }
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/ai.event.classification.modal/ai.event.classification.modal.component.ts